/* eslint-disable sonarjs/no-duplicate-string */
import { CoodeSdk, CoodeSdkOptions, Environments } from '@coode/fe-sdk';

export const coodeSdkConfig: CoodeSdkOptions = {
    environment: process.env.VUE_APP_ENVIRONMENT as Environments,
    auth: {
        msal: {
            auth: {
                clientId: process.env.VUE_APP_CLIENT_ID || '',  // ToDo: update VUE_APP_CLIENT_ID value in .env files for uat & prd
                authority: process.env.VUE_APP_AUTHORITY_URL,
                redirectUri: window.location.origin,
                postLogoutRedirectUri: `${window.location.origin}/logged-out.html`,
            },
            cache: {
                cacheLocation: 'localStorage',
            },
            system: {
                loggerOptions: 0 as any,
            },
        },
    },
    insights: {
        appInsightsConnectionString: process.env.VUE_APP_APPINSIGHT_CONNECTION_STRING
    },
};

export const sdk = new CoodeSdk(coodeSdkConfig);
